// RFLXNS — cart success micro-interaction — added 2026-04-30
window.rflxnsShowCartSignal = window.rflxnsShowCartSignal || ((message = 'PIECE SECURED', detail = 'The vault has been updated.') => {
  let signal = document.querySelector('[data-rflxns-cart-signal]');

  if (!signal) {
    signal = document.createElement('div');
    signal.className = 'rflxns-cart-signal';
    signal.setAttribute('data-rflxns-cart-signal', '');
    signal.setAttribute('role', 'status');
    signal.setAttribute('aria-live', 'polite');
    signal.innerHTML = `
      <span class="rflxns-cart-signal__mark" aria-hidden="true"></span>
      <span class="rflxns-cart-signal__copy">
        <strong></strong>
        <small></small>
      </span>
    `;
    document.body.appendChild(signal);
  }

  signal.querySelector('strong').textContent = message;
  signal.querySelector('small').textContent = detail;
  signal.classList.remove('is-visible');

  window.requestAnimationFrame(() => {
    signal.classList.add('is-visible');
  });

  window.clearTimeout(signal.rflxnsHideTimer);
  signal.rflxnsHideTimer = window.setTimeout(() => {
    signal.classList.remove('is-visible');
  }, 2400);
});

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // RFLXNS — product card variant rail — added 2026-04-21
        this.setupRflxnsCardVariantControls();
      }

      setupRflxnsCardVariantControls() {
        const variantButtons = Array.from(this.querySelectorAll('[data-rflxns-card-variant-id]'));
        if (!variantButtons.length) return;

        variantButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled || button.dataset.rflxnsCardVariantAvailable === 'false') return;

            this.variantIdInput.value = button.dataset.rflxnsCardVariantId;
            this.variantIdInput.disabled = false;

            variantButtons.forEach((variantButton) => {
              const isSelected = variantButton === button;
              variantButton.classList.toggle('is-active', isSelected);
              variantButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            });
          });
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitter = evt.submitter || this.submitButton;
        const directCheckout = submitter?.dataset.directCheckout === 'true';
        const submitButtons = Array.from(this.querySelectorAll('[type="submit"]'));
        const submitButtonText = submitter?.querySelector('span');

        if (submitter?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const originalSubmitText = submitButtonText?.dataset.originalText || submitButtonText?.textContent;
        if (submitButtonText && originalSubmitText) {
          submitButtonText.dataset.originalText = originalSubmitText;
          submitButtonText.textContent = 'ADDING...';
        }

        submitButtons.forEach((button) => button.setAttribute('aria-disabled', true));
        submitter?.classList.add('loading');
        submitter?.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = submitter?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              submitter.setAttribute('aria-disabled', true);
              if (submitButtonText) submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart && !directCheckout) {
              window.location = window.routes.cart_url;
              return;
            }

            if (submitButtonText) {
              const originalText = submitButtonText.dataset.originalText || originalSubmitText || 'ADD TO BAG';
              submitButtonText.textContent = 'IN YOUR BAG';
              window.setTimeout(() => {
                submitButtonText.textContent = originalText;
                delete submitButtonText.dataset.originalText;
              }, 1500);
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const cartSync = window.rflxnsCartService
              ? window.rflxnsCartService.syncAfterAdd(response, {
                  openDrawer: !directCheckout,
                  showSignal: !directCheckout,
                  quickAddModal,
                })
              : Promise.resolve();

            this.closest('.rflxns-product-card')?.dispatchEvent(
              new CustomEvent('rflxns:quick-add-success', { bubbles: true })
            );

            if (directCheckout) {
              return cartSync.then(() => {
                window.location = `${window.shopUrl}/checkout`;
              });
            }

            return cartSync;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitter?.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) submitButtons.forEach((button) => button.removeAttribute('aria-disabled'));
            if (this.error && submitButtonText?.dataset.originalText) {
              submitButtonText.textContent = submitButtonText.dataset.originalText;
              delete submitButtonText.dataset.originalText;
            }
            submitter?.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
